module.exports = __webpack_public_path__ + "img/view.c3f7c264.svg";